/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureSourceAccountAttributes {
  /**
  * ID of the Azure tenant the subscription belongs to.
  */
  'tenantId': string;
  /**
  * ID of the Azure subscription.
  */
  'subscriptionId': string;
  /**
  * Name of the Azure resource group the source account is scoped to.
  */
  'resourceGroupName'?: string;
  /**
  * Resource group name for Eon\'s temporary internal resources. 
  */
  'eonInternalResourceGroupName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonInternalResourceGroupName",
      "baseName": "eonInternalResourceGroupName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSourceAccountAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}

